/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">

      <img src="https://img.flyh5.cn/java/image/1684318515989.png" style="width: 50px">
      <span >{{name}}</span>
    </div>
    <el-menu-item :index="'/'+homeMenu.url">
      <template slot="title">
        <i class="iconfont" :class="homeMenu.icon"></i>
        <span>{{homeMenu.menuname}}</span>
      </template>
    </el-menu-item>
    <el-submenu v-for="menu in allmenu" :key="menu.id" :index="menu.menuName">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuName}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.children" :index="'/'+chmenu.path" :key="chmenu.id">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuName}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { qryMenuByRole } from '../api/userMG'
import { qryPlatform } from '../api/platformApi'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      name:'',
      version:'',
      allmenu: [],
      homeMenu:{
        icon: 'icon-provider-manage',
        menuname: '首页',
        url: 'charts/statistics'
      },
      user: {}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    qryMenuByRole({roleId:this.user.roleId==null?'':this.user.roleId})
      .then(res => {
        if(undefined == res || res.code==0){
          this.$store.commit('logout', 'false');
          this.$router.push({ path: '/login' })
          return;
        }
        if (res.code==1) {
          this.allmenu = res.data;
          this.$store.state.userMenu = res.data;
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
      .catch(err => {
        this.$message.error('系统异常，请稍后再试！')
      })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
    var data={
      dataName:'PROGRAM_RULE'
    }
    qryPlatform(data).then(res =>{
      if(undefined == res || res.code==0){
        this.$store.commit('logout', 'false');
        this.$router.push({ path: '/login' })
        return;
      }
      if (res.code==1) {
        this.name=res.data.name;
        this.version=res.data.version;
      }
    }).catch(err =>{
      this.$message.error('系统异常，请稍后再试！')
    })
  },

}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue